module.exports = __webpack_public_path__ + "static/media/forwardArrow.f9adb164.svg";